interface GetShiftInfoKeyParams {
  date: Date;
  name: string;
}

export function getShiftInfoKey(getShiftInfoKeyParams: GetShiftInfoKeyParams): string {
  const { date, name } = getShiftInfoKeyParams;
  return `${name}-${date.toISOString()}`;
}
